import { render, staticRenderFns } from "./TabAchievement.vue?vue&type=template&id=621a45ae&scoped=true&"
import script from "./TabAchievement.vue?vue&type=script&lang=js&"
export * from "./TabAchievement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621a45ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\customControl\\custom_stage_lv\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('621a45ae')) {
      api.createRecord('621a45ae', component.options)
    } else {
      api.reload('621a45ae', component.options)
    }
    module.hot.accept("./TabAchievement.vue?vue&type=template&id=621a45ae&scoped=true&", function () {
      api.rerender('621a45ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/web/isv/kingdee/hr/talentPortrait/components/tabItem/TabAchievement.vue"
export default component.exports